import * as React from "react";
import { forwardRef } from "react";
const SvgSubtract = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Property 1=24" }, /* @__PURE__ */ React.createElement("g", { id: "Group 110" }, /* @__PURE__ */ React.createElement("path", { id: "Bottom", d: "M6.34312 11.9999H17.6568", stroke: "currentColor", strokeLinecap: "round" }))));
const ForwardRef = forwardRef(SvgSubtract);
export default ForwardRef;
